import CoordenadoriaList from './list';

export default function CoordenadoriaPage() {
  return <CoordenadoriaList />;
}
